/* eslint-disable import/prefer-default-export */
const qs = require('qs');
const _ = require('lodash');

const isActionAssigneeMatchCompanyStaffV2 = (assignees = [], companyStaff) => !!assignees.find((item) => item.company_staff && item.company_staff.id === companyStaff.id);

const composeUrlWithQuery = (url, query) => {
  if (_.isEmpty(query)) {
    return url;
  }
  const stringifiedQuery = qs.stringify(query);
  return `${url}?${stringifiedQuery}`;
};

exports.isActionAssigneeMatchCompanyStaffV2 = isActionAssigneeMatchCompanyStaffV2;
exports.composeUrlWithQuery = composeUrlWithQuery;
